import AxiosService from "../AxiosService";

export class SessionService {
  constructor() {
    this.service = new AxiosService();
  }

  invalidateSession() {
    return this.service.get(`/api/invalidate-session`);
  }
}
